<template>

  <span>

    <RankUpDown class="keywordCount" :settings="{ colour: 'grey', value: settings.keywordCount, zeroOK: zeroOK }" />

    <span class="inTopWrap">

      <RankUpDown class="inTop" title="Keywords that have gone up since the last check" :settings="{ colour: 'green', value: settings.goneUp, zeroOK: zeroOK }" />

      <RankUpDown class="inTop" title="Keywords that have stayed the same since the last check" :settings="{ colour: 'orange', value: settings.same, zeroOK: zeroOK }" />

      <RankUpDown class="inTop" title="Keywords that have gone down since the last check" :settings="{ colour: 'red', value: settings.goneDown, zeroOK: zeroOK }" />

    </span>

  </span>

</template>

<script>
import RankUpDown from './RankUpDown.vue'
export default {
  name: 'KeywordCount',
  props: ['settings'],
  components: {RankUpDown},
  data() {
	return {
	  
	}
  },
  computed: {
    zeroOK () {
      return ( typeof this.settings.zeroOK !== 'undefined' && this.settings.zeroOK === true )
    }
  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
.keywordCount {
  padding-right: 8px;
  display: inline-block;
}
.inTopWrap {
  display: inline-block;
}
.inTop {
  display: inline-block;
  &.inTop3 {
    color: @green;
  }
  &.inTop10 {
    color: @orange;
  }
  &.inTop50 {
    color: @red;
  }
}
.keywordCount, .inTop {
  margin-bottom: 4px;
}
</style>